import { Alert, Button, FormHelperText, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPlanoContas from "../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import BasicDatePicker from "../../../../../../../components/BasicDatePicker";
import SelectContaCaixaBanco from "../../../../../../../components/SelectsSimpleApiQuery/SelectContaCaixaBanco";
import { formatarInputValorMonetário } from "../../../../../../../helpers/masks";
import { useState } from "react";

export default function Step01() {

  const { getValues, control, handleSubmit, watch, setError, clearErrors } = useFormContext()

  const handleNext = getValues('funcoesAux.onNext')

  const [errorContas, setErrorContas] = useState<boolean>(false)
  const contaBancaria = watch("step01.conta_bancaria")

  const handleValidateInputs = (data: any) => {
    const { step01 } = data
    const contaContabil = step01.conta_bancaria.codigo
    const contraPartida = step01.contra_partida.codigo_contabil
    if (contaContabil === contraPartida) {
      setErrorContas(true)
      setError("step01.conta_bancaria", {
        type: 'error'
      });
      setError("step01.contra_partida", {
        message: '',
        type: 'error'
      });
      return false
    } else {
      setErrorContas(false)
      clearErrors("step01.conta_bancaria");
      clearErrors("step01.contra_partida");
    }
    return true;
  }

  const handleNextStep = (data: any) => {
    if (!handleValidateInputs(data)) return;
    handleNext()
  }

  return (
    <Grid container spacing={2}>
      {
        errorContas &&
        <Grid size={{xs: 12 }}>
          <Alert severity="warning">As contas contábeis precisam ser diferentes</Alert>
        </Grid>
      }
      <Grid size={{xs: 6}}>
        <Controller
          name="step01.conta_bancaria"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid, error } }) => (
            <>
              <SelectContaCaixaBanco
                {...field}
                required
                error={invalid}
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => {
                  field.onChange(valor)
                }}
              />
              {
                contaBancaria && contaBancaria !== "" && !invalid &&
                <FormHelperText sx={{ ml: 2, color: '#014361', fontWeight: 'bold' }}>Saldo atual {formatarInputValorMonetário(String(contaBancaria.saldo))}</FormHelperText>
              }
            </>
          )}
        />
      </Grid>
      <Grid size={{xs: 6}}>
        <Controller
          name="step01.contra_partida"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid, error } }) => (
            <SelectPlanoContas
              inputLabel="Contra partida"
              value={field.value}
              required
              error={invalid}
              errorMessage={error?.message}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ tipo: "Analítica" }}
            />
          )}
        />
      </Grid>
      <Grid size={{xs:5}}>
        <Controller
          name="step01.data_lancamento"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <BasicDatePicker
              label="Data do lançamento"
              value={field.value}
              formatString="DD/MM/YYYY"
              error={invalid}
              onChange={(data) => { field.onChange(data) }}
            />
          )}
        />
      </Grid>
      <Grid size={{xs: 3}}>
        <Controller
          name="step01.debito_credito"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="D/C"
              value={field.value}
              onChange={(valor) => {
                const newValue = valor.target.value.toUpperCase();
                if (newValue === 'D' || newValue === 'C' || newValue === '') {
                  field.onChange(newValue);
                }
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{xs: 4}}>
        <Controller
          name="step01.valor"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Valor"
              value={field.value}
              onChange={(e) => {
                const formattedValue = formatarInputValorMonetário(e.target.value)
                field.onChange(formattedValue);
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{xs: 12 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleNextStep)}
        >
          Avançar
        </Button>
      </Grid>
    </Grid>
  )
}
